import React, { useEffect, useState } from "react";
// libs
import styled from "styled-components";
import axios from "src/libs/axios";
// components
import CustomHead from "src/components/ui/CustomHead";
import Layout from "src/layout";
import HomeContainer from "src/components/containers/home";
// hooks
import useAllPage from "src/hooks/dynamic/allPage";
import { useReviews, useServices } from "src/hooks/services";
import { getCountry } from "src/utils/countries";
// theme
import { colors } from "src/theme/colors";
// types
import { GetStaticProps, NextPage } from "next";
import { IReview, IService } from "src/types";
// const
import { ENDPOINTS } from "src/constants/endpoints";
import { PetOrVetModal } from "src/components/ui/Modals/PetOrVet";

const Wrapper = styled.div`
  background-color: ${colors.main};
  overflow: hidden;
`;

interface IHomePage {
  reviews: IReview[];
  services: IService[];
  clinicsByCity: any;
}

const HomePage: NextPage<IHomePage> = ({ reviews, services, clinicsByCity }) => {
  const [showPetOrVetModal, setShowPetOrVetModal] = useState(false);
  const searchSection = {};
  const servicesSection = { services };
  const reviewsSection = { reviews };

  useEffect(() => {
    if (!localStorage.getItem("pa-visitorType")) {
      setShowPetOrVetModal(true);
    }
  }, []);

  return (
    <>
      <CustomHead />

      {showPetOrVetModal && (
        <PetOrVetModal isOpen={showPetOrVetModal} setIsOpen={setShowPetOrVetModal} />
      )}

      <Wrapper>
        <Layout headerProps={{ styles: { width: "1096px" } }}>
          <HomeContainer
            searchSection={searchSection}
            servicesSection={servicesSection}
            reviewsSection={reviewsSection}
            clinicsByCity={clinicsByCity}
          />
        </Layout>
      </Wrapper>
    </>
  );
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  const { loadReviews } = useReviews();
  const { loadServices } = useServices();

  const { name } = getCountry(ctx.locale, "locale") || {};

  const getCitiesByCountry = async () => {
    const result = await axios.get(`${ENDPOINTS.GET.getClinicsByCity}?country=${name}`);
    return result.data;
  };

  const [reviews, services, clinicsByCity, initialReduxState] = await Promise.all([
    loadReviews(`_sort=created_at:desc&_limit=20&rating_gte=4&clinic.country=${name}`),
    loadServices("_sort=name:desc"),
    getCitiesByCountry(),
    useAllPage(ctx.locale as string),
  ]);

  return {
    props: {
      initialReduxState,
      reviews,
      services,
      clinicsByCity,
    },
    revalidate: 10, // 10 Second Cache
  };
};

export default HomePage;
